import { LogoutOutlined } from '@ant-design/icons';
import { Button, Flex, Layout, Space, Spin, theme, Typography } from 'antd';

import { useUserInfo } from '@/api';
import { useAuth } from '@/providers/AuthContext';

export function MainHeader() {
  const { token: themeToken } = theme.useToken();
  const { logout } = useAuth();
  const { data, isLoading } = useUserInfo();

  const userText = data
    ? `${data.user.firstName} ${data.user.lastName} (${data.user.role} / ${data.organization.number})`
    : '';

  const organizationText = `${data?.organization.name}` || '';

  return (
    <Layout.Header
      style={{
        backgroundColor: themeToken.colorWhite,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0 24px',
      }}
    >
      <Space size={16}>
        {isLoading ? (
          <Spin />
        ) : (
          <Flex vertical={true} align={'right'}>
            <Typography.Text direction={'rtl'} strong={true}>
              {userText}
            </Typography.Text>
            <Typography.Text>{organizationText}</Typography.Text>
          </Flex>
        )}
        <Button icon={<LogoutOutlined />} onClick={logout} />
      </Space>
    </Layout.Header>
  );
}
